import { createFileRoute, notFound } from '@tanstack/react-router';

import { lazyScreen } from '@/shared/screen/lazy-screen';

// As telas reais de Carteiras sobre o MSW do módulo, sem login (T9.A). Só em dev: em produção a rota
// responde 404 e o chunk nem é pedido. As telas navegam num roteador próprio, no `#` da URL.
export const Route = createFileRoute('/dev/carteiras/')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-page'), 'WalletDevPage') : () => null,
});
